import React, {Fragment, useState} from "react";


import Header from "../components/Header/Header";
import 'react-toastify/dist/ReactToastify.css';
import Footercom from "../components/Footer/Footercom";



    const Master_Front = (props) => {

    return (
      <Fragment>


          <Header  backgroundtr={"header-not-transparentbk"}  wallet_balance={props.wallet_balance} first_name_profile={props.first_name_profile} last_name_profile={props.last_name_profile}    />

    <main className={'box_front_master w-100 box_container_bk ' + String(props.custom_class_main)}  >


        {props.children}




        { String(props.bottom_navbar_show)=="hide" ?  (

            <Fragment></Fragment>

        ) : (
            <Fragment>
                {/*<Nav />*/}
            </Fragment>

        ) }



    </main>


          <Footercom />

      </Fragment>
    );
  }

  export default Master_Front;